import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Permissions, TokenPermissions } from '../data/permissions';
import { BookService } from './book.service';

// Ponemos aquí unos permisos algo restrictivos, por si acaso el backend falla, para evitar que se muestren cosas que no deberían mostrarse. Luego el backend debería devolver los permisos reales y sobreescribirlos.
const DEFAULT_PERMISSIONS: Set<TokenPermissions> = new Set(
  [
    TokenPermissions.SEE_BOOK,
    TokenPermissions.SEE_STUDY,
    TokenPermissions.SHARE,
  ]);

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  tourMode: "none" | "basic" | "cookies" | "always" = 'none';
  /** Permisos del usuario */
  permissions: Set<TokenPermissions> = DEFAULT_PERMISSIONS;

  // get permissions() {
  //   return this._permissions;
  // }

  // set permissions(ps: Set<TokenPermissions>) {
  //   this._permissions = ps;
  //   if (this.bookMode == 'prescriptor') {
  //     this.permissions.add(TokenPermissions.OPEN_IMAGE_PREVIEW)
  //     this.permissions.add(TokenPermissions.SEE_STUDY)
  //     this.permissions.add(TokenPermissions.SEE_HISTORIC_STUDIES)
  //     this.permissions.add(TokenPermissions.CALL_DOCTOR)
  //   }
  // }

  constructor(
    private bookService: BookService,
  ) {
    if (environment.demo) {
      this.permissions = new Set([
        TokenPermissions.SEE_BOOK,
        TokenPermissions.SEE_STUDY,
        TokenPermissions.SEE_HISTORIC,
        TokenPermissions.SEE_HISTORIC_STUDIES,
        TokenPermissions.SEE_HISTORIC_REPORTS,
        TokenPermissions.SHARE,
        TokenPermissions.SHARE_WITH_PERMS,
        TokenPermissions.DOWNLOAD,
        TokenPermissions.CALL_DOCTOR,
        TokenPermissions.OPEN_IMAGE_PREVIEW,
      ])
      // this.setBookMode('prescriptor');
    } else {
      this.bookService.getDefaultPermissions().then(permissions => {
        this.permissions = new Set(Permissions.sanitizeAll(permissions));;
      });
      // this.setBookMode('patient');
    }
  }

  hasPermission(perm: TokenPermissions): boolean {
    if (this.permissions == null) return false;
    return this.permissions.has(perm);
  }

  // setBookMode(mode: 'patient' | 'prescriptor') {
  //   this.bookMode = mode;
  //   this.refreshModePermissions();
  // }

  //["none","basic","cookies","always"],
  setTourMode(mode: "none" | "basic" | "cookies" | "always") {

    this.tourMode = mode;
  }

  // toggleBookMode() {
  //   if (this.bookMode == 'patient')
  //     this.bookMode = 'prescriptor';
  //   else
  //     this.bookMode = 'patient';
  //   this.refreshModePermissions();
  // }

  // refreshModePermissions() {
  //   if (this.bookMode == 'patient') {
  //     this.permissions.delete(TokenPermissions.OPEN_IMAGE_PREVIEW)
  //     this.permissions.delete(TokenPermissions.SEE_STUDY)
  //     this.permissions.delete(TokenPermissions.SEE_HISTORIC_STUDIES)
  //     this.permissions.delete(TokenPermissions.CALL_DOCTOR)
  //   }
  //   if (this.bookMode == 'prescriptor') {
  //     this.permissions.add(TokenPermissions.OPEN_IMAGE_PREVIEW)
  //     this.permissions.add(TokenPermissions.SEE_STUDY)
  //     this.permissions.add(TokenPermissions.SEE_HISTORIC_STUDIES)
  //     this.permissions.add(TokenPermissions.CALL_DOCTOR)
  //   }
  // }

}
